<template>
  <section class="container">
    <h1>Talent Recruitment</h1>
    <ul class="countact_zp">
      <li v-for="item in list" :key="item.id" :class="{ closure: !item.active }" @click="item.active = !item.active">
        <div class="label">
          <div class="name">{{ item.title }}</div>
          <p>{{ item.work_time }}</p>
          <p>{{ item.edu }}</p>
          <p>{{ item.peoples }}人</p>
          <div class="btn"></div>
        </div>
        <div class="rich_box" :style="{ height: `${item.height}px` }">
          <div class="rich" v-html="item.content"></div>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
import service from "@/assets/js/service";

export default {
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.setSlideUp();
  },
  created() {
    this.contactJoblist();
  },
  methods: {
    async contactJoblist() {
      let res = await service.contactJoblist();
      this.list = res.data.joblist;
    },
    setSlideUp() {
      document.querySelectorAll(".countact_zp li").forEach((item, index) => {
        this.list[index].active = true;
        setTimeout(() => {
          this.list[index].height =
            item.querySelector(".rich_box").clientHeight;
          this.list[index].active = false;
        }, 0);
      });
    },
  },
};
</script>

<style lang="less" scoped>
h1 {
  font-size: 30px;
  margin-bottom: 30px;
}

ul {
  li {
    box-shadow: 0 4px 20px rgba(0, 73, 152, 0.07);

    .label {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 30px 50px;

      .name {
        font-size: 20px;
      }

      p {
        font-size: 16px;
        color: #666;
      }

      .btn {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        background: var(--themeColor2);
        position: relative;
        cursor: pointer;
        transition: all 0.3s;

        &::after,
        &::before {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 20px;
          height: 3px;
          background: #fff;
          transition: all 0.3s;
        }

        &::before {
          transform: translate(-50%, -50%) rotate(360deg);
        }

        &::after {
          transform: translate(-50%, -50%) rotate(-360deg);
        }
      }
    }

    .rich_box {
      overflow: hidden;
      transition: all 0.3s;

      .rich {
        border-top: 1px solid #eee;
        padding: 45px 50px;
      }
    }

    &.closure {
      .label .btn {
        background: var(--themeColor);

        &::before {
          transform: translate(-50%, -50%) rotate(90deg);
        }
      }

      .rich_box {
        height: 0 !important;
      }
    }

    &+li {
      margin-top: 20px;
    }
  }
}

@media (max-width: 700px) {
  ul {
    li {
      .label {
        justify-content: space-between;
        flex-wrap: wrap;

        .name {
          width: 80%;
        }

        p {
          margin-top: 10px;

          &:first-of-type {
            width: 33%;
          }

          text-align: center;
          order: 999;
        }
      }
    }
  }
}

@media (max-width: 500px) {
  ul {
    li {
      .label {
        padding: 30px 20px;
      }

      .rich_box {
        .rich {
          padding: 20px;
        }
      }
    }
  }
}
</style>